import { Injectable } from '@angular/core';
import { IGarmentWizardService } from '../../../+common/contracts/garment-wizard.service.contract';
import { IPerson } from '../../../+common/contracts/person.model.contract';
import { Product } from '../model/product.model';
import { ProductCategory } from '../model/product-category.model';
import { GarmentFull } from '../model/garment-full.model';
import { Garment } from '../model/garment.model';

@Injectable()
export class MockGarmentWizardService implements IGarmentWizardService {
  private _selectedPerson: IPerson;
  private _selectedProductCategory: ProductCategory;
  private _selectedProduct: Product;
  private _garmentFull: GarmentFull;

  get selectedPerson(): IPerson {
    return this._selectedPerson;
  }
  get selectedProductCategory(): ProductCategory {
    return this._selectedProductCategory;
  }
  get selectedProduct(): Product {
    return this._selectedProduct;
  }
  get garmentFull(): GarmentFull {
    return this._garmentFull;
  }

  set selectedPerson(v) {
    this._selectedPerson = v;
  }
  set selectedProductCategory(v) {
    this._selectedProductCategory = v;
  }
  set selectedProduct(v) {
    this._selectedProduct = v;
  }
  set garmentFull(v) {
    this._garmentFull = v;
  }
}



// WEBPACK FOOTER //
// ./src/app/+core/common/mock/mock-garment-wizard.service.ts